import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api, money } from "@/lib/api";

const quand = (j) => (j < 0 ? `échéance passée depuis ${-j} j, aucun paiement trouvé` : j === 0 ? "aujourd'hui" : `dans ${j} jours`);

// Bandeau : acomptes TPS/TVQ non payés dont l'échéance arrive dans 14 jours ou moins
export const RappelAcomptes = () => {
  const [liste, setListe] = useState([]);
  useEffect(() => { api.get("/acomptes-taxes/prochains").then((r) => setListe(r.data)).catch(() => {}); }, []);
  if (!liste.length) return null;
  return (
    <div className="mb-6 flex flex-wrap items-start gap-3 rounded-lg border border-sky-200 bg-sky-50 px-4 py-3" data-testid="rappel-acomptes">
      <CalendarClock className="mt-0.5 h-4 w-4 shrink-0 text-sky-700" />
      <div className="flex-1 min-w-0 text-sm text-sky-900">
        <p className="font-medium">Acompte TPS/TVQ à verser</p>
        {liste.map((a) => (
          <p key={`${a.annee}-${a.date}`} data-testid={`rappel-acompte-${a.date}`}>Acompte {a.annee} : {money(a.montant)} au plus tard le {a.date} · {quand(a.jours)}</p>
        ))}
      </div>
      <Link to="/commentaires#acomptes" className="text-sm font-medium text-emerald-700 hover:underline" data-testid="rappel-acomptes-voir">Voir les acomptes</Link>
    </div>
  );
};
